// src/index.js
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css"; // ✅ IMPORTANT: loads Manrope + CSS variables + global styles
import App from "./App";
import { reportCaughtError } from "./training/TrainingResultsBoundary";


const root = ReactDOM.createRoot(document.getElementById("root"), { onCaughtError: reportCaughtError });

root.render(
  <React.StrictMode>
        <App />
  </React.StrictMode>
);
